import React from 'react';
import { any, func, string, shape, bool } from 'prop-types';
import { pick, compose } from 'ramda';

const buttonAttributs = ['name', 'type', 'onClick', 'disabled', 'data-cy'];

const getButtonProps = (props) => pick(buttonAttributs, props);

const formatButtonProps = () => (WrappedComponent) => (props) => {
  return <WrappedComponent buttonProps={{ ...getButtonProps(props) }} {...props} />;
};

const Button = (props) => {
  const { children, buttonProps, className, getRef, isProcessing } = props;
  return (
    <button ref={(ref) => getRef && getRef(ref)} {...buttonProps} className={`btn ${className}`}>
      {children}
      {isProcessing && (
        <span className="pl-half">
          <i className="icon icon-loader" />
        </span>
      )}
    </button>
  );
};

Button.defaultProps = {
  className: '',
  isProcessing: false
};

Button.propTypes = {
  children: any,
  getRef: func,
  className: string,
  isProcessing: bool,
  buttonProps: shape({
    name: string,
    type: string,
    onClick: func,
    disabled: bool
  })
};
export default compose(formatButtonProps())(Button);
